import { render, staticRenderFns } from "./verify-username.vue?vue&type=template&id=1df48fb4&"
import script from "./verify-username.vue?vue&type=script&lang=js&"
export * from "./verify-username.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "verify-username.vue"
export default component.exports